import React, { useEffect } from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { Box, RadioGroup, FormControlLabel, Radio } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { Schedule } from '@epi-constants/benefitTypes';
import { FormFields, createRules } from '@epi-forms/helpers';
import { required } from '@epi-helpers/formHelpers/validators';
import {
  today,
  December,
  TOMORROW,
  END_OF_NEXT_YEAR,
  END_OF_YEAR,
  isTomorrow
} from '@epi-helpers/TopupHelper';

import { TerminationDatePicker } from '@epi-pages/Beneficiaries/components/TerminationDate/components/TerminationDatePicker';

const scheduleType = FormFields.ScheduleType;
const scheduleDate = FormFields.ScheduleDate;

export const TopupSchedule = () => {
  const { control, setValue } = useFormContext();
  const { t } = useTranslation();
  const validators = [required];
  const disabledCustomDates =
    today > December
      ? { before: TOMORROW, after: END_OF_NEXT_YEAR }
      : { before: TOMORROW, after: END_OF_YEAR };

  const {
    field: { value: valueType, onChange }
  } = useController({
    name: scheduleType,
    control
  });

  const {
    field: { value: valueDate, onChange: dateOnChange },
    fieldState: { error }
  } = useController({
    name: scheduleDate,
    control,
    rules: createRules(valueType === Schedule.SelectDate ? validators : [])
  });

  const isError = error ? !!error : valueDate && !isTomorrow(valueDate);

  useEffect(() => {
    if (valueType === Schedule.Direct) {
      setValue(scheduleDate, undefined);
    }
  }, [valueType]);

  return (
    <Box fontSize={16} fontWeight={400} position="relative" top={3}>
      <RadioGroup onChange={onChange} value={valueType}>
        <Box display="flex" gap={1} flexDirection="column">
          <FormControlLabel
            value={Schedule.Direct}
            control={<Radio />}
            label={t('containers.deposit_money.topup_tab.form.schedule.direct')}
            id="choose-as-direct"
          />
          <FormControlLabel
            value={Schedule.SelectDate}
            control={<Radio />}
            label={t(
              'containers.deposit_money.topup_tab.form.schedule.select_date'
            )}
            id="choose-as-select-date"
          />
        </Box>
      </RadioGroup>
      {valueType === Schedule.SelectDate ? (
        <Box display="flex" flexDirection="row" alignItems="end">
          <TerminationDatePicker
            dayValue={valueDate}
            setTerminationDate={dateOnChange}
            isError={isError}
            title={t(
              'containers.deposit_money.topup_tab.form.schedule.select_date_title'
            )}
            disabledCustomDates={disabledCustomDates}
            errorText={t(
              'containers.deposit_money.topup_tab.form.schedule.error_text'
            )}
          />
        </Box>
      ) : null}
    </Box>
  );
};
